import { forwardRef, useImperativeHandle } from 'react'
import { crmApi } from '@/api'
import { Lead, LeadPaymentLink } from '@/api/types/crm.types'
import usePagination from '@/hooks/usePagination'
import Preloader from '@UI/Preloader'
import { Empty } from 'antd'
import { LoadingOutlined, ReloadOutlined } from '@ant-design/icons'
import Button from '@UI/New/Button'
import Pagination from '@UI/New/Pagination'
import PurchasesLinkItem from './PurchasesLinkItem'
import classes from './index.module.css'
import cn from 'classnames'
import { useAsync } from 'react-use'

interface PurchasesLinksListProps {
  lead: Lead
}

export interface PurchasesLinksListHandle {
  refetchQuery: () => void
}

const PurchasesLinksList = forwardRef<
  PurchasesLinksListHandle,
  PurchasesLinksListProps
>(({ lead }, ref) => {
  const {
    state: dirtyData,
    loading,
    getState: refetchQuery,
    setState,
    ...paginationParams
  } = usePagination({
    api: crmApi.getLeadPaymentLinks,
    params: {
      expand: ['class', 'course', 'tariff'],
      lead_id: lead.id,
    },
  })
  const data = (dirtyData || []) as LeadPaymentLink[]

  useImperativeHandle(ref, () => ({
    refetchQuery,
  }))

  return (
    <>
      <div className={cn('custom-scroll', classes.list)}>
        {loading ? (
          <div className={classes.preloaderWrapper}>
            <Preloader fullScreen="app" />
          </div>
        ) : data.length < 1 ? (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={'У вас пока нету ссылок на покупки для этого лида'}
            className={classes.empty}
          />
        ) : (
          data.map((item) => (
            <PurchasesLinkItem
              key={item.id}
              lead={lead}
              link={item}
              refetchLinks={refetchQuery}
            />
          ))
        )}
      </div>
      <div className={classes.paginationWrapper}>
        <Pagination {...paginationParams} />
        <Button
          color="white"
          style={{ position: 'relative' }}
          onClick={() => refetchQuery()}
          disabled={loading}
          leftContent={
            loading ? (
              <LoadingOutlined
                onPointerEnterCapture={undefined}
                onPointerLeaveCapture={undefined}
              />
            ) : (
              <ReloadOutlined
                onPointerEnterCapture={undefined}
                onPointerLeaveCapture={undefined}
              />
            )
          }
        >
          Обновить
        </Button>
      </div>
    </>
  )
})

export default PurchasesLinksList
